/* ==========================================================================
   Frag Yumi – Verhalten
   - Einstieg auf Kategorieseiten öffnet ein Sheet mit allen Fragen (Liste)
   - Eine Frage zeigt Antwort + passende Produkte (Section Rendering API)
   - Zurück-Taste: Antwort -> Liste -> zu
   - Mobil Bottom Sheet (wischen zum Schliessen), Desktop Dialog
   - Produktreihen: wischen (Touch) bzw. Pfeile (Maus)
   - Direkt in den Warenkorb für Produkte mit einer Variante
   - Übersichtsseite: Kategorie-Tabs, aufklappbare Fragen mit Lazy-Load
   ========================================================================== */
(function () {
  if (window.FragYumi) return;
  window.FragYumi = true;

  var SECTION_ID = 'frag-yumi-produkte';
  var cache = {};

  /* ---------- Helfer ---------- */
  /* Tracking: Shopify-Kundenereignisse (Custom Pixel -> GA4) und, falls vorhanden, gtag/dataLayer */
  function track(name, params) {
    params = params || {};
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, params);
      }
    } catch (err) {}
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params);
      } else if (Array.isArray(window.dataLayer)) {
        var e = { event: name };
        for (var k in params) e[k] = params[k];
        window.dataLayer.push(e);
      }
    } catch (err) {}
  }

  /* Bestell-Markierung: Warenkorb-Attribut "_frag_yumi" mit den Fragen, aus denen
     ein Produkt geöffnet oder in den Warenkorb gelegt wurde. Erscheint in der Bestellung. */
  var ATTR = '_frag_yumi';
  function markiere(frage) {
    if (!frage) return;
    try {
      var liste = (sessionStorage.getItem('fy_fragen') || '').split(',').filter(Boolean);
      if (liste.indexOf(frage) === -1) liste.push(frage);
      liste = liste.slice(-5);
      sessionStorage.setItem('fy_fragen', liste.join(','));
      var attrs = {}; attrs[ATTR] = liste.join(', ');
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {});
    } catch (err) {}
  }

  function ladeProdukte(url, handle) {
    if (cache[handle]) return cache[handle];
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    cache[handle] = fetch(url + sep + 'section_id=' + SECTION_ID, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector('.fy-produkte');
      })
      .catch(function () {
        delete cache[handle];
        return null;
      });
    return cache[handle];
  }

  /* Pfeile für Maus-Bedienung an eine Produktreihe hängen */
  function pfeile(reihe) {
    if (!reihe || reihe.parentNode.classList.contains('fy-reihe-wrap')) return;
    var wrap = document.createElement('div');
    wrap.className = 'fy-reihe-wrap';
    reihe.parentNode.insertBefore(wrap, reihe);
    wrap.appendChild(reihe);
    var zurueck = document.createElement('button');
    var vor = document.createElement('button');
    zurueck.type = vor.type = 'button';
    zurueck.className = 'fy-pfeil fy-pfeil--zurueck';
    vor.className = 'fy-pfeil fy-pfeil--vor';
    zurueck.setAttribute('aria-label', 'Vorherige Produkte');
    vor.setAttribute('aria-label', 'Weitere Produkte');
    wrap.appendChild(zurueck);
    wrap.appendChild(vor);
    function schritt(richtung) {
      reihe.scrollBy({ left: richtung * Math.max(160, reihe.clientWidth * 0.8), behavior: 'smooth' });
    }
    zurueck.addEventListener('click', function () { schritt(-1); });
    vor.addEventListener('click', function () { schritt(1); });
    function status() {
      var max = reihe.scrollWidth - reihe.clientWidth - 2;
      zurueck.disabled = reihe.scrollLeft <= 2;
      vor.disabled = reihe.scrollLeft >= max;
      wrap.classList.toggle('kann-scrollen', max > 2);
    }
    reihe.addEventListener('scroll', status, { passive: true });
    window.addEventListener('resize', status);
    setTimeout(status, 50);
  }

  function fuelleProdukte(ziel, url, handle) {
    if (!ziel.querySelector('.fy-lade') && !ziel.querySelector('.fy-produkte')) {
      ziel.insertAdjacentHTML('beforeend', '<div class="fy-lade" aria-hidden="true"><span></span><span></span><span></span></div>');
    }
    return ladeProdukte(url, handle).then(function (el) {
      var lade = ziel.querySelector('.fy-lade');
      if (lade) lade.remove();
      var alt = ziel.querySelector('.fy-produkte');
      if (alt) alt.remove();
      if (!el || el.getAttribute('data-fy-anzahl') === '0') {
        ziel.hidden = true;
        return;
      }
      ziel.hidden = false;
      var kopie = el.cloneNode(true);
      ziel.appendChild(kopie);
      pfeile(kopie.querySelector('.fy-reihe'));
    });
  }

  /* ---------- Warenkorb ---------- */
  function warenkorbZaehler() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        ['.header-cart__count', '.header-cart__count--badge', '[data-cart-count]', '[data-bind="itemCount"]',
          '.cart-badge', '.cart_count', '.cart-link__bubble-num', '#CartCount'].forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) { el.textContent = cart.item_count; });
        });
        document.querySelectorAll('.header-cart, [data-ajax-cart-trigger]').forEach(function (w) {
          w.classList.toggle('has-cart-count', cart.item_count > 0);
        });
        ['cart:updated', 'cart:refresh', 'cart:add', 'cart:item-added', 'ajaxCart:refresh', 'cart.requestComplete']
          .forEach(function (n) { document.dispatchEvent(new CustomEvent(n, { detail: cart })); });
        if (window.PXUTheme && typeof window.PXUTheme.cartRefresh === 'function') {
          try { window.PXUTheme.cartRefresh(cart); } catch (e) {}
        }
      })
      .catch(function () {});
  }

  var toastTimer;
  function toast(html) {
    var t = document.querySelector('.fy-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'fy-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
    }
    /* Ein offenes Sheet liegt im Top Layer, dort muss der Toast hinein */
    var ziel = sheet && sheet.open ? sheet : document.body;
    if (t.parentNode !== ziel) ziel.appendChild(t);
    t.innerHTML = html;
    requestAnimationFrame(function () { t.classList.add('is-sichtbar'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-sichtbar'); }, 3200);
  }

  var aktuelleFrage = null;
  /* Eigene Antwortseite: Frage aus dem Artikel übernehmen */
  (function () {
    var seite = document.querySelector('.fy-seite[data-fy-handle]');
    if (seite) aktuelleFrage = seite.getAttribute('data-fy-handle');
  })();

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fy-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-laedt')) return;
    var text = btn.querySelector('.fy-produkt__kaufen-text') || btn;
    btn.classList.add('is-laedt');
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-fy-add')), quantity: 1, properties: aktuelleFrage ? { _frag_yumi: aktuelleFrage } : {} }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        btn.classList.remove('is-laedt');
        btn.classList.add('is-drin');
        text.textContent = '✓ Im Warenkorb';
        toast('In den Warenkorb gelegt <a href="/cart">Zum Warenkorb</a>');
        warenkorbZaehler();
        var ort = (btn.closest('[data-fy-ort]') || document.body).getAttribute('data-fy-ort') || 'sheet';
        track('frag_yumi_in_warenkorb', { produkt: btn.getAttribute('data-fy-titel'), frage: aktuelleFrage || '', ort: ort });
        markiere(aktuelleFrage);
      })
      .catch(function () {
        btn.classList.remove('is-laedt');
        toast('Das hat leider nicht geklappt. Bitte über die Produktseite bestellen.');
      });
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-fy-produkt-link]');
    if (!link) return;
    track('frag_yumi_produkt_klick', { frage: aktuelleFrage || '', produkt: (link.getAttribute('href') || '').split('?')[0].split('/').pop(), position: Number(link.getAttribute('data-fy-position')) || 0 });
    markiere(aktuelleFrage);
  });

  /* ---------- Sheet ---------- */
  var sheet, inhalt, zurueckBtn, wer, aktiveKarte = null, tiefe = 0, ansicht = null;

  function baueSheet(avatarSrc) {
    sheet = document.createElement('dialog');
    sheet.className = 'fy-sheet';
    sheet.setAttribute('aria-labelledby', 'fy-sheet-titel');
    sheet.setAttribute('data-fy-ort', 'sheet');
    sheet.innerHTML =
      '<div class="fy-sheet__griff" data-fy-zieh></div>' +
      '<div class="fy-sheet__kopfzeile" data-fy-zieh>' +
        '<button type="button" class="fy-sheet__zurueck" data-fy-zurueck hidden><span aria-hidden="true"></span>Alle Fragen</button>' +
        '<div class="fy-sheet__wer">' +
          '<span class="fy-avatar fy-avatar--klein" aria-hidden="true">' + (avatarSrc ? '<img src="' + avatarSrc + '" alt="">' : '') + '</span>' +
          '<span>Frag Yumi</span>' +
        '</div>' +
        '<button type="button" class="fy-sheet__zu" aria-label="Schliessen" data-fy-zu>&times;</button>' +
      '</div>' +
      '<div class="fy-sheet__inhalt"></div>';
    document.body.appendChild(sheet);
    inhalt = sheet.querySelector('.fy-sheet__inhalt');
    zurueckBtn = sheet.querySelector('[data-fy-zurueck]');
    wer = sheet.querySelector('.fy-sheet__wer');

    sheet.addEventListener('click', function (e) {
      if (e.target === sheet || e.target.closest('[data-fy-zu]')) schliessen();
      else if (e.target.closest('[data-fy-zurueck]')) history.back();
    });
    sheet.addEventListener('cancel', function (e) { e.preventDefault(); schliessen(); });

    /* Wischen nach unten schliesst */
    var startY = null, dy = 0;
    sheet.addEventListener('touchstart', function (e) {
      if (!e.target.closest('[data-fy-zieh]') || e.target.closest('button')) return;
      startY = e.touches[0].clientY; dy = 0;
      sheet.classList.add('is-zieht');
    }, { passive: true });
    sheet.addEventListener('touchmove', function (e) {
      if (startY === null) return;
      dy = Math.max(0, e.touches[0].clientY - startY);
      sheet.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    sheet.addEventListener('touchend', function () {
      if (startY === null) return;
      sheet.classList.remove('is-zieht');
      startY = null;
      if (dy > 90) schliessen(); else sheet.style.transform = '';
    });

    window.addEventListener('popstate', function (e) {
      if (!sheet.open) return;
      tiefe = Math.max(0, tiefe - 1);
      if (e.state && e.state.fy === 'liste' && aktiveKarte) {
        zeigeListe(false);
      } else {
        tiefe = 0;
        schliessenJetzt();
      }
    });
  }

  function sheetAuf() {
    sheet.style.transform = '';
    sheet.classList.remove('is-schliesst');
    if (!sheet.open) {
      if (typeof sheet.showModal === 'function') sheet.showModal(); else sheet.setAttribute('open', '');
      document.documentElement.classList.add('fy-gesperrt');
    }
    inhalt.scrollTop = 0;
  }

  function merke(zustand) {
    try { history.pushState({ fy: zustand }, ''); tiefe++; } catch (e) {}
  }

  function zeigeListe(neu) {
    var tpl = aktiveKarte && aktiveKarte.querySelector('template[data-fy-liste-tpl]');
    if (!tpl) return;
    ansicht = 'liste';
    aktuelleFrage = null;
    inhalt.innerHTML = '';
    inhalt.appendChild(tpl.content.cloneNode(true));
    zurueckBtn.hidden = true;
    wer.hidden = false;
    sheetAuf();
    if (neu) merke('liste');
  }

  function zeigeAntwort(handle, ausListe) {
    var tpl = aktiveKarte && aktiveKarte.querySelector('template[data-fy-antwort="' + handle + '"]');
    if (!tpl) return;
    var url = tpl.getAttribute('data-fy-url');
    ansicht = 'antwort';
    aktuelleFrage = handle;
    inhalt.innerHTML = '';
    inhalt.appendChild(tpl.content.cloneNode(true));

    if (tpl.getAttribute('data-fy-produkte') !== '0') {
      var box = document.createElement('div');
      box.className = 'fy-sheet__produkte';
      box.innerHTML = '<p class="fy-zwischentitel fy-zwischentitel--klein">Das passt dazu</p>';
      inhalt.appendChild(box);
      fuelleProdukte(box, url, handle);
    }
    var mehr = document.createElement('a');
    mehr.className = 'fy-mehr';
    mehr.href = url;
    mehr.innerHTML = 'Antwort als eigene Seite öffnen <span aria-hidden="true">→</span>';
    inhalt.appendChild(mehr);

    var hatListe = !!aktiveKarte.querySelector('template[data-fy-liste-tpl]');
    zurueckBtn.hidden = !hatListe;
    wer.hidden = hatListe;
    sheetAuf();
    if (ausListe) {
      merke('antwort');
    } else if (!tiefe) {
      /* Direkt aus der Zeile geöffnet: "Alle Fragen" bzw. Zurück führt zur Liste */
      if (hatListe) merke('liste');
      merke('antwort');
    }
    track('frag_yumi_frage', { frage: handle, ort: aktiveKarte.getAttribute('data-fy-ort') || 'kollektion' });
  }

  function vorbereiten(karte) {
    aktiveKarte = karte;
    if (!sheet) {
      var img = karte.querySelector('.fy-teaser__yumi img');
      baueSheet(img ? img.getAttribute('src') : '');
    }
  }

  function schliessenJetzt() {
    if (!sheet || !sheet.open) return;
    var fertig = function () {
      sheet.classList.remove('is-schliesst');
      sheet.style.transform = '';
      if (typeof sheet.close === 'function') sheet.close(); else sheet.removeAttribute('open');
      document.documentElement.classList.remove('fy-gesperrt');
      aktuelleFrage = null;
      ansicht = null;
    };
    if (window.matchMedia('(max-width: 798px)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      sheet.classList.add('is-schliesst');
      setTimeout(fertig, 220);
    } else {
      fertig();
    }
  }

  function schliessen() {
    if (tiefe > 0) {
      var n = tiefe;
      tiefe = 0;
      history.go(-n); /* popstate schliesst */
      setTimeout(schliessenJetzt, 400);
    } else {
      schliessenJetzt();
    }
  }

  document.addEventListener('click', function (e) {
    var liste = e.target.closest('[data-fy-liste]');
    if (liste) {
      e.preventDefault();
      var karte = liste.closest('[data-fy-karte]');
      if (!karte) return;
      vorbereiten(karte);
      zeigeListe(true);
      track('frag_yumi_geoeffnet', { ort: karte.getAttribute('data-fy-ort') || 'kollektion' });
      return;
    }
    var btn = e.target.closest('[data-fy-open]');
    if (btn) {
      e.preventDefault();
      if (!aktiveKarte) {
        var k = btn.closest('[data-fy-karte]');
        if (!k) return;
        vorbereiten(k);
      }
      zeigeAntwort(btn.getAttribute('data-fy-handle'), ansicht === 'liste');
    }
  });

  /* ---------- Frage-Seite: Pfeile an der Produktreihe ---------- */
  function initFrageSeite(root) {
    root.querySelectorAll('.fy-reihe').forEach(pfeile);
  }

  /* ---------- Übersichtsseite ---------- */
  function initRatgeber(root) {
    var tabs = root.querySelectorAll('[data-fy-tab]');
    var gruppen = root.querySelectorAll('[data-fy-gruppe]');

    function zeigeTab(name) {
      tabs.forEach(function (t) {
        var aktiv = t.getAttribute('data-fy-tab') === name;
        t.classList.toggle('is-aktiv', aktiv);
        t.setAttribute('aria-selected', aktiv ? 'true' : 'false');
        if (aktiv && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      });
      gruppen.forEach(function (g) {
        g.hidden = !(name === 'alle' || g.getAttribute('data-fy-gruppe') === name);
      });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        zeigeTab(t.getAttribute('data-fy-tab'));
        track('frag_yumi_kategorie', { kategorie: t.getAttribute('data-fy-tab') });
      });
    });

    root.querySelectorAll('details.fy-frage').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        var handle = d.getAttribute('data-fy-handle');
        track('frag_yumi_frage', { frage: handle, ort: 'ratgeber' });
        var ziel = d.querySelector('[data-fy-ziel]');
        if (ziel && !ziel.getAttribute('data-geladen')) {
          ziel.setAttribute('data-geladen', '1');
          aktuelleFrage = handle;
          fuelleProdukte(ziel, d.getAttribute('data-fy-url'), handle);
        }
      });
    });

    function springeZu(handle) {
      var d = document.getElementById('fy-' + handle);
      if (!d) return;
      zeigeTab('alle');
      d.open = true;
      setTimeout(function () { d.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 30);
    }
    root.querySelectorAll('[data-fy-sprung]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        springeZu(a.getAttribute('data-fy-sprung'));
        try { history.replaceState(null, '', '#fy-' + a.getAttribute('data-fy-sprung')); } catch (err) {}
      });
    });
    if (location.hash.indexOf('#fy-') === 0) springeZu(location.hash.slice(4));

    var kopf = document.querySelector('.mobile-header, .header-sticky-wrapper, .sticky-header, [data-sticky-header]');
    if (kopf) {
      var st = getComputedStyle(kopf);
      if (st.position === 'fixed' || st.position === 'sticky') {
        root.style.setProperty('--fy-tabs-top', kopf.getBoundingClientRect().height + 'px');
      }
    }
  }

  function init() {
    document.querySelectorAll('.fy-seite').forEach(initFrageSeite);
    document.querySelectorAll('[data-fy-ratgeber]').forEach(initRatgeber);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
